import React, {useState} from "react";
import {Field} from "formik";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

import DimensionsModal from "../../components/TablePro/fields/DimensionsField";
import labels from "../../constants/displayFields";

export default function DimensionsField(props) {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    if (props.disabled) return;

    setOpen(v => !v);
  };

  return (
    <Field {...props}>
      {({ field, form, meta }) => {
        const values = field.value || [];
        const errorMessage = meta.error || form.errors[field.name];
        const error = (meta.touched || form.submitCount > 0) && errorMessage;

        const handleSave = (dimensions) => {
          form.setFieldValue(field.name, dimensions);
          if (props.handleUpdateAssetField && props.asset) {
            props.handleUpdateAssetField("dimensions")(dimensions, {
              onSuccess: (data) => {
                if (data?.asset?.squareFootage) {
                  form.setFieldValue("squareFootage", data.asset.squareFootage);
                }
                if (data?.asset?.cubicFootage) {
                  form.setFieldValue("cubicFootage", data.asset.cubicFootage);
                }
              }
            });
          }
        };

        return (
          <>
            <FormControl fullWidth>
              <TextField
                size="small"
                disabled={props.disabled}
                autoComplete="off"
                label={'Dimensions (W" x D" x H")'}
                value={values
                  .map(field => [field.width, field.depth, field.height].join("x"))
                  .join(", ")}
                variant="outlined"
                margin="none"
                error={!!error}
                helperText={error}
                inputProps={{ onClick: handleToggle }}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    handleToggle();
                  }
                }}
              />
            </FormControl>
            {open && (
              <DimensionsModal
                field={{ label: labels.dimensions }}
                onSubmit={handleSave}
                value={values}
                nextRow={undefined}
                onClose={handleToggle}
              />
            )}
          </>
        );
      }}
    </Field>
  );
}
